import { IconButton } from '@/shared/components/ui/button/icon/icon-button.component';
import { CopySimple } from '@phosphor-icons/react';
import copy from 'copy-to-clipboard';
import { FC } from 'react';
import { toast } from 'sonner';

export const CopyInputValue: FC<{
  value: string;
}> = ({ value }) => {
  return (
    <div className="absolute right-[16px] top-1/2 -translate-y-1/2">
      <IconButton
        id="button-copy-api-token"
        type="button"
        hoverAnimations={false}
        onClick={() => {
          copy(value);
          toast.success('Copiado com sucesso!');
        }}
      >
        <CopySimple size={25} />
      </IconButton>
    </div>
  );
};
